import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center gap-[30px]" }
const _hoisted_2 = { class: "flex gap-[4px] flex-nowrap items-center justify-center whitespace-nowrap" }
const _hoisted_3 = { class: "text-Text/text_high font-gordita-medium" }
const _hoisted_4 = {
  key: 1,
  style: {"margin":"0px 4px 0 0"},
  class: "w-[20px] h-[20px] pt-[1px] flex justify-center items-center text-Text/text_medium cursor-pointer hover:text-Text/text_high hover:bg-Hovers/hover_primary rounded-[50%]"
}
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" No matches found ")

import { IncrediButton, IncrediMenu, IncrediList, IncrediItem, IncrediField } from 'incredi-ui';

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'selection-menu',
  props: {
    searchable: { type: Boolean },
    label: null,
    options: null,
    modelValue: null,
    maxHeight: null,
    disabled: { type: Boolean }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:model-value', value: string | null): void }), expose: any, slots: any, attrs: any }) {

const searchInputModel = ref('');
const isSearchFocused = ref(false);
const menuOpen = ref(false);
const handleMenuButtonClick = (e: MouseEvent) => {
  if (menuOpen.value) {
    e.stopPropagation();
    menuOpen.value = false;
  }
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IncrediMenu), {
          direction: "bottom-sticky-left",
          "offset-y": 4,
          "offset-x": 0,
          "model-value": __props.disabled ? false : menuOpen.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = (e) => menuOpen.value = e)
        }, {
          content: _withCtx(() => [
            _createVNode(IbxScopedCss, {
              ref: "menuRef",
              style: {"width":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IncrediList), {
                  class: "selection-menu--incredi-list",
                  style: _normalizeStyle({
                maxHeight: `${__props.maxHeight}px`,
              })
                }, {
                  default: _withCtx(() => [
                    (__props.searchable)
                      ? (_openBlock(), _createBlock(_unref(IncrediField), {
                          key: 0,
                          ref: "searchInput",
                          modelValue: searchInputModel.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInputModel).value = $event)),
                          class: "incredi-search--container mb-[8px]",
                          name: "search-input",
                          label: "Seach",
                          size: "tiny",
                          clearable: "",
                          onFocusWithin: _cache[2] || (_cache[2] = ($event: any) => (isSearchFocused.value = true)),
                          onFocusout: _cache[3] || (_cache[3] = ($event: any) => (isSearchFocused.value = false))
                        }, {
                          prepend: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("i", {
                                class: _normalizeClass([isSearchFocused.value ? 'text-Text/text_primary' : 'text-System/app_grey_76', "uil uil-search text-[24px] mr-2"])
                              }, null, 2)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.filter(option => option.toLowerCase().includes(searchInputModel.value.toLowerCase())), (option, index) => {
                      return (_openBlock(), _createBlock(_unref(IncrediItem), {
                        key: index,
                        class: "cursor-pointer",
                        selected: option === __props.modelValue,
                        onClick: (e) => {emit('update:model-value', option); menuOpen.value = false;}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option), 1)
                        ]),
                        _: 2
                      }, 1032, ["selected", "onClick"]))
                    }), 128)),
                    (!__props.options.filter(option => option.toLowerCase().includes(searchInputModel.value.toLowerCase())).length)
                      ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                          key: 1,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            }, 512)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_unref(IncrediButton), {
                design: "ghost-neon",
                size: "tiny",
                selected: menuOpen.value || !!__props.modelValue,
                "override-style": {
              height: '32px',
              padding: '10px 8px',
            },
                disabled: __props.disabled,
                onClick: handleMenuButtonClick
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(__props.label) + _toDisplayString(__props.modelValue ? ':' : ''), 1),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.modelValue), 1),
                    (!__props.modelValue)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(["uil uil-angle-down text-Text/text_medium", {
                  '!text-text/text_disabled': __props.disabled,
                }]),
                          style: {"font-size":"20px","margin":"0 6px 0 0"}
                        }, null, 2))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("i", {
                            class: "uil uil-times field-icon !m-0",
                            style: {"font-size":"20px"},
                            onClick: _cache[0] || (_cache[0] = _withModifiers((e) => emit('update:model-value', null), ["prevent","stop"]))
                          })
                        ]))
                  ])
                ]),
                _: 1
              }, 8, ["selected", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["model-value"])
      ])
    ]),
    _: 1
  }))
}
}

})